export const USER_GROUPS = {
  ADMINISTRATOR: 1,
};
